import { parseErpReadDeskQuery, serializeErpReadDeskQuery } from '~/composables/erpReadDesk/query'
import type { ErpReadDeskQuery } from '~/composables/erpReadDesk/types'

const ADMIN_HOME = '/admin/designs'
const ERP_READ_DESK_PATH = '/admin/erp-read'

function queryRecord(searchParams: URLSearchParams): Record<string, string> {
  return Object.fromEntries(searchParams.entries())
}

export function erpReadDeskReturnTo(query: ErpReadDeskQuery): string {
  const search = new URLSearchParams(serializeErpReadDeskQuery(query)).toString()
  return search ? `${ERP_READ_DESK_PATH}?${search}` : ERP_READ_DESK_PATH
}

export function resolveAdminReturnTo(candidate: unknown): string {
  if (typeof candidate !== 'string' || !candidate.startsWith('/') || candidate.startsWith('//')) return ADMIN_HOME

  let url: URL
  try {
    url = new URL(candidate, 'https://admin.local')
  }
  catch {
    return ADMIN_HOME
  }
  if (url.origin !== 'https://admin.local' || url.pathname !== ERP_READ_DESK_PATH) return ADMIN_HOME

  const query = parseErpReadDeskQuery(queryRecord(url.searchParams))
  return erpReadDeskReturnTo(query)
}

export function adminLoginHref(returnTo: string): string {
  return `/admin/login?returnTo=${encodeURIComponent(resolveAdminReturnTo(returnTo))}`
}

export function adminGoogleLoginHref(returnTo: string): string {
  return `/auth/google?returnTo=${encodeURIComponent(resolveAdminReturnTo(returnTo))}`
}
